import { Button } from '@hakimo-ui/shared/ui-base';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';

interface Props {
  handleBulkSafe: () => void;
}

export function BulkResolveBanner(props: Props) {
  const { handleBulkSafe } = props;
  return (
    <div className="flex items-center justify-end gap-2 p-2">
      <span className="text-sm">Resolve All alarms as</span>
      <Button
        variant="primary"
        onClick={handleBulkSafe}
        className="flex items-center gap-2"
      >
        <ShieldCheckIcon className="h-5 w-5" />
        <span>Safe</span>
      </Button>
    </div>
  );
}

export default BulkResolveBanner;
